import React from 'react';

import {
    FormGroup,
    Col,
    FormControl,
    ControlLabel
} from 'react-bootstrap';


module.exports = class DropDown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: ''
        };
    }

    changeValue(val) {
        if (this.props.status == "show" || (this.props.disabled && this.props.disabled == true)) {
            var all = this.props.options;
            for (var i = 0; i < all.length; i++) {
                if (all[i].key == val) {
                    this.setState({ value: all[i].value });
                    break;
                }
            }

        }
        else {
            var element = document.getElementById(this.props.id);
            element.value = val;
        }
    }
    render() {
        var rows = this
            .props
            .options
            .map((option) => <option value={option.key} key={option.key}>{option.value}</option>);

        var input;
        if (this.props.status == "show" || (this.props.disabled && this.props.disabled == true)) {
            input = <label>{this.state.value}</label>
        }
        else {
            input = <select id={this.props.id} name={this.props.id} className='form-control'>
                {rows}
            </select>
        }
        return (
            <FormGroup>
                <Col componentClass={ControlLabel} lg={2}>
                    {this.props.caption}
                </Col>
                <Col lg={10}>
                    {input}
                </Col>
            </FormGroup>
        )
    }
};


// WEBPACK FOOTER //
// ./modules/register/DropDown.jsx